export default __webpack_public_path__ + "static/media/Header1234copy.93284ad6.png";